import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  useAsyncCall,
  GridContainer,
  GridItem,
  fillNonNullValues,
  isNotEmpty,
  SubmitFormButton,
  handleFormSubmission,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { FormProvider } from "react-hook-form";
import React, { useEffect } from "react";
import { UserDetails } from "../../../../../../types/userTypes";
import { saveUserMainDetails } from "../../../../../../axios/api/services";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import { createUserValidationSchema } from "../../../../../../yup/schema/users/userValidationSchema";
import AccountFormSection from "../../../../users/account/common/account/AccountFormSection";
import PersonFormSection from "../../../../users/account/common/person/PersonFormSection";
import RepresentativeFormSection from "../../../../users/account/common/representative/RepresentativeFormSection";
import ContactAddressFormSection from "../../../../users/account/common/address/ContactAddressFormSection";
import ResultReceiveFormSection from "../../../../users/account/common/resultReceive/ResultReceiveFormSection";
import ReceiverAddressFormSection from "../../../../users/account/common/address/ReceiverAddressFormSection";
import AccountVerificationFormSection from "../../../../users/account/common/account/AccountVerificationFormSection";
import { userDataAdminUpdateInitialValues } from "../../../../../../init/userDataAdminUpdateInitialValues";

const getDefaultValues = (user): UserDetails => {
  const updatedUser = { ...userDataAdminUpdateInitialValues };
  fillNonNullValues(user, updatedUser);
  return updatedUser;
};

const UserMainDetailsForm = ({ user }) => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();

  const { methods } = useReactHookForm<UserDetails>({
    defaultValues: getDefaultValues(user),
    validationSchema: createUserValidationSchema,
  });

  useEffect(() => {
    if (user) {
      methods.reset(getDefaultValues(user));
    }
  }, [user, methods]);

  const submitUser = (values) => {
    const isEdit = values.id !== "";
    if (isEdit) {
      const saveUser: AsyncCallArgs = {
        promise: saveUserMainDetails(values),
        reactHooksForm: { methods },
        onSuccess: (response) => {
          if (isNotEmpty(response.personalNacidId)) {
            methods.setValue("personalNacidId", response.personalNacidId);
          } else {
            methods.setValue("personalNacidId", "");
          }
          toast.success(t("m.user.update.success"));
        },
      };
      asyncCall(saveUser);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleFormSubmission({ methods, onSubmitFn: submitUser, t })}>
        <AccountFormSection isPublicSection={false} />
        <AccountVerificationFormSection />
        <PersonFormSection />
        <RepresentativeFormSection />
        <ContactAddressFormSection />
        <ResultReceiveFormSection />
        <ReceiverAddressFormSection />

        <GridContainer spacing={3} mt={0}>
          <GridItem sm={12} md={12}>
            <Typography align={"right"}>
              <SubmitFormButton label={"l.btn.save"} />
            </Typography>
          </GridItem>
        </GridContainer>
      </form>
    </FormProvider>
  );
};

export default UserMainDetailsForm;
